const sx = {
	mainBox() {
		return { width: 'calc(100% - 260px)', flexGrow: 1 };
	},
	container({ container }) {
		return {
			...(container && { px: { xs: 0, sm: 2 } }),
			position: 'relative',
			minHeight: 'calc(100vh - 60px)',
			display: 'flex',
			flexDirection: 'column',
			pt: { xs: 2, sm: 3 },
			pb: { xs: 2, sm: 3 },
		};
	},
	wrap() {
		return {
			display: 'flex',
			backgroundColor: 'background.default',
		};
	},
	innerAside() {
		return {
			p: 2,
			width: 360,
			minWidth: 360,
			backgroundColor: 'background.paper',
			borderRight: '1px solid',
			borderRightColor: 'divider',
		};
	},
};

export default sx;
